import { createStyles } from "@mantine/core";

export default createStyles ( ( theme, props ) => {

	return {
		typographyTest: {
			fontSize   : theme.other.typographyNew.fontSizeMapping[props?.variant],
			fontWeight : theme.other.typographyNew.fontWeightMapping[props?.fontWeight],
			lineHeight : 1.5,
			color      : theme.other.colors.text.primary
		},
		typography: {
			fontFamily : "\"Roboto\",\"Helvetica\",\"Arial\",sans-serif",
			color      : props?.dimmed !== undefined ? theme.other.colors.text.secondary : props?.color === "secondary" ?
				theme.other.colors.text.secondary :
				props?.color === "primary" ?
					theme.other.colors.text.primary :
					props?.color,
			textTransform: "none"
		},
		noWrap: {
			overflow     : "hidden",
			textOverflow : "ellipsis",
			whiteSpace   : "nowrap"
		}
	};
} );
